export * from './src/modal-dialog.module';
export * from './src/modal-dialog.service';
export * from './src/modal-dialog.component';
export * from './src/simple-modal.component';
